/**
 * Merchant Configuration CrossFrame Listeners
 *
 * Partners tab (JwoRetailerConfigurationsUITool) reads and writes of Keystone merchant configs through the
 * Gateway. One consolidated read, like the store configurations read; one write per section, each mapped to
 * its own AVP action. The Gateway checks the action against the requested merchant and rejects config types
 * that don't belong to the section.
 */

import { GetMerchantConfigurationsInput } from '@amzn/coral_com-amazon-jwo-store-configurations/GetMerchantConfigurationsInput'
import { GetMerchantConfigurationsOutput } from '@amzn/coral_com-amazon-jwo-store-configurations/GetMerchantConfigurationsOutput'
import { UpdateMerchantConfigurationInput } from '@amzn/coral_com-amazon-jwo-store-configurations/UpdateMerchantConfigurationInput'
import { UpdateMerchantConfigurationOutput } from '@amzn/coral_com-amazon-jwo-store-configurations/UpdateMerchantConfigurationOutput'
import { getServiceClient } from '@api/client-factory/StoreManagementClientFactory'
import { validateRequired } from './listenerUtils'

/** All merchant config types (profile, billing/mailing address, bank statement). Required: merchantId */
export async function getMerchantConfigurationsListener (message: any): Promise<GetMerchantConfigurationsOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'merchantId')
    const client = getServiceClient()
    return client.getMerchantConfigurations(GetMerchantConfigurationsInput.clone({ merchantId: params.merchantId })).toPromise()
}

function updateInput (message: any): UpdateMerchantConfigurationInput {
    const params = (message && message.data) || {}
    validateRequired(params, 'merchantId', 'keystoneConfigs')
    return UpdateMerchantConfigurationInput.clone({ merchantId: params.merchantId, keystoneConfigs: params.keystoneConfigs })
}

/** friendly_name, contact_phone. Required: merchantId, keystoneConfigs */
export async function updateMerchantDetailsListener (message: any): Promise<UpdateMerchantConfigurationOutput> {
    const input = updateInput(message)
    return getServiceClient().updateMerchantDetails(input).toPromise()
}

/** billing_address. Required: merchantId, keystoneConfigs */
export async function updateMerchantBillingAddressListener (message: any): Promise<UpdateMerchantConfigurationOutput> {
    const input = updateInput(message)
    return getServiceClient().updateMerchantBillingAddress(input).toPromise()
}

/** bank_statement. Required: merchantId, keystoneConfigs */
export async function updateBankStatementSettingsListener (message: any): Promise<UpdateMerchantConfigurationOutput> {
    const input = updateInput(message)
    return getServiceClient().updateBankStatementSettings(input).toPromise()
}
